import React from "react";
import ChooseSide from "components/HomePage/ChooseSide";

const HomePage = () => {
  return (
    <>
      <h1 className="page__title">Home</h1>
      <ChooseSide />
    </>
  );
};

export default HomePage;
